import PolicyPage from "../components/PolicyPage";

export default function Privacy() {
  return (
    <PolicyPage
      kind="privacy"
      title="Privacy Policy — How we handle your data."
      intro="This policy explains what personal and medical information Dr. Indresh Dixit's practice collects when you use this website or book an appointment, how it is used, and how it is protected."
      sections={[
        {
          id: "info-we-collect",
          heading: "Information we collect",
          body: "When you contact us through this website, WhatsApp, or phone, we may collect your name, contact number, age, gender, and a brief description of the medical concern you'd like consulted. During clinic visits, we additionally maintain standard clinical records — history, examination findings, investigation reports, and treatment notes — as required for medical care and by law.",
        },
        {
          id: "how-we-use",
          heading: "How we use it",
          bullets: [
            "To confirm and schedule your appointment.",
            "To prepare for your consultation and provide continuity of care across visits.",
            "To communicate appointment reminders, follow-up instructions, and report availability.",
            "To meet medico-legal record-keeping requirements under Indian law.",
          ],
        },
        {
          id: "what-we-do-not",
          heading: "What we never do",
          bullets: [
            "We do not sell, rent or trade your personal or medical information.",
            "We do not share medical records with third parties without your written consent, except where required by law.",
            "We do not run advertising profiles based on your medical data.",
          ],
        },
        {
          id: "third-party",
          heading: "Third-party services",
          body: "This website uses standard analytics (such as Google Analytics or similar) to understand aggregate usage patterns and improve content. These tools may use cookies and collect anonymised technical data (browser, device, page views). They do not have access to your medical records or any information you submit through WhatsApp/phone.\n\nEmbedded YouTube videos and Google Maps may set their own cookies as per their respective privacy policies.",
        },
        {
          id: "your-rights",
          heading: "Your rights",
          bullets: [
            "You can request a copy of any personal/medical information we hold about you.",
            "You can ask us to correct inaccurate information.",
            "You can request deletion of personal data we are not required by law to retain.",
            "You can opt out of non-essential communication at any time.",
          ],
        },
        {
          id: "contact-us",
          heading: "Contact us",
          body: "For any privacy-related question, write to the clinic or call +91 93696 98080. We respond within 5 working days.",
        },
      ]}
    />
  );
}
